import {vpost} from "@/util/post";

export const product = {
    listAll: (client, typeId, keyword, pageCurrent, pageSize) => {
        let dto = {
            client,
            categoryId: typeId,
            pageCurrent, pageSize,
            keyword
        }

        return vpost("/product/listAll", dto);
    },
    /**
     * 更新商品的可见性
     * @param productId 商品编号
     * @param viewFor
     * @returns {Promise<void>}
     */
    updateProductView: async (productId, viewFor) => {
        const dto = {
            productId,
            viewFor
        };
        return (await vpost("/product/updateProductViewFor", dto));
    },

    listTypes() {
        return vpost("/product/listTypes");
    },

    save(product) {
        return vpost("/product/save", product);
    },

}
